import { useUserStore } from "@/stores/userStore";

export default (axios) => ({
    getSliders() {
        return axios.get(`/sliders`);
    },
    getCategories(){
        return axios.get('/categories')
    },
    getNotifications(id) {
        return axios.get(`/notifications/user/${id}`, {
            headers: {
                Authorization: `Bearer ${useUserStore().getAccessToken}`
            }
        });
    },
    getUnreadNotificationsCount() {
        return axios.get(`/notifications/user/count/${useUserStore().getmca_no}`, {
            headers: {
                Authorization: `Bearer ${useUserStore().getAccessToken}`
            }
        });
    },
    markReadNotificationsCount() {
        return axios.post(`/notifications/read/${useUserStore().getmca_no}`,{}, {
            headers: {
                Authorization: `Bearer ${useUserStore().getAccessToken}`
            }
        });
    },
    getHomeCategories(){
        return axios.get('/categories/home/category')
    },
    getAllMedia(){
        return axios.get('/media')
    },
    getAllMediaByCategory(slug,type){
        return axios.get('/media/category/'+slug+'/'+type)
    },
    getCards(){
        return axios.get('/home-pages')
    },
    getMedia(){
        return axios.get('/media')
    },
    getBlogs(){
        return axios.get('/blogs/');
    },
    getBlog(id){
        return axios.get('/blogs/'+id);
    },
    getResourceCategories(type){
        return axios.get('/media-categories/all/'+type);
    },
    getAlbumImages(id,type){
        return axios.get('/media/'+id+'/album/'+type);
    },
  });
  